<template>
  <div>
    <div v-if="product.isHighlight == 'true' && product.type == 'Pre-cast Fence' && product.isActive == true">
      <section id="precastsection" class="section section-container-hero section-shaped my-0">
        <div class="sameHeaderContent heroprecast">
          <div class="col-lg-12 pt-4 pb-4 display-1 text-header">
            {{ product.name }}
            <div class="hr-line"></div>
          </div>
        </div>
        <div class="container shape-container d-flex align-items-center">
          <div class="col p-3">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-6 col-md mt-5 mb-0">
                <div v-html="product.specification"></div>
                <base-button tag="a" href="/pre-cast-fence" class="mb-3 mt-5 mb-sm-0 btn-outline-primary inquire"
                  type="white">
                  DISCOVER MORE
                </base-button>
              </div>
              <div class="col-lg-6 col-md mt-5 mb-0">
                <div class="columnandpanel">
                  <img class="img-fluid" :src="productImageUrl" alt="column and panel" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-if="product.isHighlight == 'true' && product.type == 'Hybrid CHB' && product.isActive == true">
      <section id="hybridsection" class="section section-container-hero section-shaped my-0">
        <div class="sameHeaderContent herohybrid">
          <div class="col-lg-12 pt-4 pb-4 display-1 text-header">
            {{ product.name }}
            <div class="hr-line"></div>
          </div>
        </div>
        <div class="container shape-container d-flex align-items-center">
          <div class="col p-3">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-6 col-md mt-5 mb-0">
                <div v-html="product.specification"></div>
                <base-button tag="a" href="/hybrid-chb" class="mb-3 mt-5 mb-sm-0 btn-outline-primary inquire"
                  type="white">
                  DISCOVER MORE
                </base-button>
              </div>
              <div class="col-lg-6 col-md mt-5 mb-0">
                <div class="columnandpanel">
                  <img class="img-fluid" :src="productImageUrl" alt="column and panel" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-highlight',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => { },
    },
  },
  computed: {
    productImageUrl() {
      return this.product.productImage.url
    },
  },
}
</script>

<style lang="scss" scoped>
.sameHeaderContent {
  background-image: url(../../../../public/img/background/optimized/productsBG.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: fit-content;
  position: relative;
}

.sameHeaderContent::after {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000b3;
  z-index: 0;
}

.sameHeaderContent>* {
  z-index: 10;
  position: relative;
}

.text-header {
  padding-left: 5rem;
  color: white;
  font-size: 3rem;
  font-weight: 600;
  width: 100%;
  text-transform: uppercase;
}

.hr-line {
  position: absolute;
  bottom: 0.5rem;
  left: -0.5rem;
  height: 0.5rem;
  width: 45%;
  background-color: #eda711;
  border-bottom-right-radius: 7px;
  border-top-right-radius: 7px;
}

.container {
  max-width: 95.33333%;
}

.inquire {
  color: #eda711;
}

.inquire:hover {
  color: white !important;
  background-color: #eda711 !important;
}

@media only screen and (max-width: 280px) {
  .text-header {
    font-size: 0.8rem !important;
    padding-left: 1rem !important;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .text-header {
    font-size: 1.1rem;
    padding-left: 1rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .text-header {
    font-size: 2rem;
    padding-left: 1rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .text-header {
    font-size: 2.5rem;
    padding-left: 1rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .text-header {
    font-size: 3rem;
    padding-left: 3rem;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .text-header {
    font-size: 3.5rem;
    padding-left: 5rem;
  }
}
</style>
